import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-service',
  templateUrl: './image-service.component.html',
  styleUrls: ['./image-service.component.css']
})
export class ImageServiceComponent  {
  @Input() data!: any;
  @Input() language!: string;

}